/* eslint-disable camelcase */
import analyticsEvent from '../../components/fseManagementSystem/utils/webViewUtils/analyticsEvent';

/*
    event_category
    event_action
    event_label: Designation
    event_label2: type
    event_label3: team
    pulse_hc1: employee id
    Screen: screen name
    event_label4: Field value
    event_label5
    event_value
*/
const pulseEvent = (
  event_category,
  event_action,
  event_label,
  event_label2,
  event_label3,
  pulse_hc1,
  Screen,
  event_label4,
  event_label5,
  event_value,
) => {
  const eventJson = {};
  if (event_category) eventJson.event_category = event_category;
  if (event_action) eventJson.event_action = event_action;
  if (event_label) eventJson.event_label = event_label;
  if (event_label2) eventJson.event_label2 = event_label2;
  if (event_label3) eventJson.event_label3 = event_label3;
  if (event_label4) eventJson.event_label4 = event_label4;
  if (event_label5) eventJson.event_label5 = event_label5;
  if (pulse_hc1) eventJson.pulse_hc1 = pulse_hc1;
  if (Screen) eventJson.screenname = Screen;
  if (event_value) eventJson.event_value = event_value;
  analyticsEvent(eventJson);
};
export default pulseEvent;
